/** 
*@author: satyamurthy.a
*@Description : 
**/
import { Input,Tooltip,Button } from 'antd';
import { connect } from 'react-redux';
import ListView from '../../../Utils/ListView';
import Highlighter from 'react-highlight-words';
import { encode as base64_encode } from 'base-64';
import { constant } from '../../../Utils/constants';
import React, { useState, useEffect, useRef } from 'react';
import translation from '../../../../../commons/translation';
import { EditOutlined, SearchOutlined } from '@ant-design/icons';
import { getDeviceTypeList, deleteDeviceType } from '../../../Utils/FormCalls';

const EquipmentTagList = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [searchText, setSearchText] = useState('');
  const searchInput = useRef(null);

  const { translationCache, navigate } = props;

  const config = {
    viewTypes: ['add', 'card', 'table'],
    defaultViewType: 'table',
    filterType: 'ByAttributeValue',
    TitleView: true,
    attributeList: ['Name', 'Description'],
    firstTitle: 'Name',
    secondTitle: 'Code',
    thirdTitle: 'Description',
    actions: ['edit'],
    edit: {
      byAttribute: 'Code',
      redirectURL: '/rubus/AMM/EquipmentTagDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const data = await getDeviceTypeList();
      setDataSource(data);
    };
    fetchData();
  }, []);

  const deleteEquipmentType = async (record) => {
    await deleteDeviceType(record.Id);
    const data = await getDeviceTypeList();
    setDataSource(data);
  };

  const editRecord = (record) => {
    navigate({ pathname: `${config.edit.redirectURL}/${base64_encode(record.Id)}` });
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(translationCache, `Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(translationCache, 'Search')}
        </Button>
        <Button
          danger
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation(translationCache, 'Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record && record[dataIndex] && record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const columns = [
    {
      title: translation(translationCache, constant.equipmentTypeName),
      dataIndex: 'Name',
      key: 'Name',
      ...getColumnSearchProps('Name')
    },
    {
      title: translation(translationCache, constant.equipmentTypeCode),
      dataIndex: 'Code',
      key: 'Code'
    },
    {
      title: translation(translationCache, constant.equipmentTypeDescription),
      dataIndex: 'Description',
      key: 'Description',
      ...getColumnSearchProps('Description')
    },
    {
      title: translation(translationCache, constant.action),
      width: '600',
      render: (text, record) => (
        <>
          <Button onClick={() => editRecord(record)}>
            <Tooltip title={translation(translationCache, 'Edit')}>
              <EditOutlined />
            </Tooltip>
          </Button>
        </>
      )
    }
  ];

  const configDetails = {
    title: translation(translationCache, constant.EQUIPMENT_TAGS),
    viewTypes: ['add', 'card', 'table'],
    defaultViewType: 'table',
    filterType: 'ByAttributeValue',
    TitleView: true,
    attributeList: ['Name', 'Code', 'Description'],
    firstTitle: 'Name',
    secondTitle: 'Code',
    thirdTitle: 'Description',
    actions: ['edit'],
    edit: {
      byAttribute: 'Code',
      redirectURL: '/rubus/AMM/EquipmentTagDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };

  return (
    <>
      <ListView
        {...props}
        columns={columns}
        dataSource={dataSource}
        config={configDetails}
        delete={deleteEquipmentType}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(EquipmentTagList);